import { fromJS } from 'immutable';

import { ApiTemplate,UserToken } from '../../../helper/HelperAuth'
import { GetTemplateFacebook } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, client_id,sender_id,template_name) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiTemplate + 'config-template-fb-all';
    if(page === undefined){
        page = 1;
    }
    let clients = [client_id];
    if (client_id == null || client_id == undefined) {
        clients = [""];
    }

    let senders = "";
    if (sender_id === undefined) {
        senders = "";
    }else{
        senders = sender_id;
    }

    if(template_name == undefined){
        template_name = ""
    }
    var query = {
        'client_id' : clients,
        'sender-id' : senders,
        'template-name':template_name,
        "page":page,
        "page-size":10,
        "order-by":1,
        "order":"ASC",
    };
    var paramBody = {
        "data": query
    };
//debugger
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
    }

    dispatch({ type: GetTemplateFacebook, data: fromJS(data) });
};